<template>
  <a
    :href="href"
    :target="target"
    class="text-primary font-medium" :textColor="''"
    @click.prevent="handleClick"
  >
  <i v-if="btnIcon" :class="btnIcon"></i>
    {{ btnText }}
  </a>
</template>

<script>
export default {
  name: 'AnchorButton',
  props: {
    href: {
      type: String,
      default: '#',
    },
    target: {
      type: String,
      default: '_blank',
    },
    btnText: {
      type: String,
      required: true,
    },
    btnIcon: {
      type: String,
      default: '',  // e.g. "fa-solid fa-pen-to-square"
    },
  },
  methods: {
    handleClick() {
      this.$emit('buttonAction');
    },
  },
};
</script>
